<mat-toolbar color="primary">
    <span class="title">Connex {{env}} Monitoring</span>

    <button class="logout-button" mat-button mat-stroked-button 
      (click)="logout()" 
      *ngIf="authenticated">Logout - {{displayName}}</button>

    <button class="login-button" mat-button mat-raised-button color="accent"
      (click)="login()" 
      *ngIf="!authenticated">Login</button>

    <button class="menu-button" mat-button mat-stroked-button 
      *ngIf="authenticated" [matMenuTriggerFor]="menu">{{currentLocation}}</button>

    <mat-menu #menu="matMenu">
        <a mat-menu-item routerLink="{{route.path}}" *ngFor="let route of routes">
          <mat-icon>{{route.data.icon}}</mat-icon>{{route.data.title}}
        </a>
    </mat-menu>
  </mat-toolbar>

  <div class="login">
    <app-login *ngIf="!authenticated"></app-login>
  </div>